module.exports = __webpack_public_path__ + "static/media/warning.779b46d8.svg";